import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit, AfterContentInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SignatureFieldComponent } from 'app/_components/signature-field/signature-field.component';

declare var $: any;

@Component({
  selector: 'app-request-question',
  templateUrl: './request-question.component.html',
})
export class RequestQuestionComponent implements OnInit, AfterContentInit {
  @Input() question: any;
  @Input() answers: any;
  @Input() screenIndex: number;
  @Input() questionIndex: number;
  @Input() states: any[];
  @Input() mealTypeOptions: any[] = [];
  @Output() attendeeEstimateChange = new EventEmitter<{screenIndex: number, questionIndex: number}>();
  @ViewChild(SignatureFieldComponent) public signatureField: SignatureFieldComponent;

  showedSubQuestion: boolean = false;

  ngOnInit() {
    if (!this.answers[this.screenIndex]) {
      this.answers[this.screenIndex] = {};
    }
    if (this.question.type_id === 'MULTIPLE_CHECK' && !this.answers[this.screenIndex][this.questionIndex]) {
      this.answers[this.screenIndex][this.questionIndex] = {};
    }
    // Initialize other text field if needed
    if (this.question.type_id === 'MULTIPLE_RADIO' || this.question.type_id === 'MULTIPLE_CHECK') {
      if (!this.answers[this.screenIndex][this.questionIndex + '_other_text']) {
        this.answers[this.screenIndex][this.questionIndex + '_other_text'] = '';
      }
    }
  }

  ngAfterContentInit() {
  }

  onChangeYNStatus(value) {
    if ((value == "Yes" && this.question.sub_type == "IFYESTHEN") || (value == 'No' && this.question.sub_type == 'IFNOTHEN')) {
      this.showedSubQuestion = true;
    } else {
      this.showedSubQuestion = false;
    }
  }

  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.answers[this.screenIndex][this.questionIndex] = {
          name: file.name,
          type: file.type,
          size: file.size,
          data: reader.result
        };
      };
    }
  }

  onRadioChange(value) {
    if (value !== '__OTHER__') {
      // Clear other text when a regular option is selected
      this.answers[this.screenIndex][this.questionIndex + '_other_text'] = '';
    }
  }

  onCheckboxChange(value) {
    if (value === '__OTHER__') {
      // If other is unchecked, clear other text
      if (!this.answers[this.screenIndex][this.questionIndex] || !this.answers[this.screenIndex][this.questionIndex]['__OTHER__']) {
        this.answers[this.screenIndex][this.questionIndex + '_other_text'] = '';
      }
    }
  }

  onAttendeeEstimateChange() {
    // Emit event when attendee estimate changes for validation
    if (this.question.type_id === 'attendee_count_estimate') {
      // Use setTimeout to ensure the model value is updated before validation
      setTimeout(() => {
        this.attendeeEstimateChange.emit({
          screenIndex: this.screenIndex,
          questionIndex: this.questionIndex
        });
      }, 0);
    }
  }
}
